export default "__VITE_ASSET__BeX8q4Nl__"